import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import AppRouter from "./routers/AppRouter";
import "dotenv/config";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import configureStore from "./redux/store/configureStore";
import {
  logoutUser,
  userLogin,
} from "./redux/actions/authentication/authentication";
import { SECRET_KEY } from "./config";
import jwt from "jsonwebtoken";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
//import swDevRegister from "./swDev";

// styles
import "./index.scss";
import "bootstrap/dist/css/bootstrap.min.css";

const store = configureStore();

let isRendered = false;

const renderApp = (): void => {
  if (!isRendered) {
    const acess_token = localStorage.getItem("User_AccessToken");
    if (acess_token) {
      store.dispatch(userLogin(jwt.verify(acess_token, SECRET_KEY)));
    } else {
      store.dispatch(logoutUser());
    }

    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <AppRouter />
          {/* <ToastContainer /> */}
        </Provider>
      </React.StrictMode>,
      document.getElementById("root")
    );

    isRendered = true;
  }
};

renderApp();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
//serviceWorkerRegistration.unregister();
serviceWorkerRegistration.register();
//swDevRegister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
